import Vue from "vue";
import VueI18n from "vue-i18n";
// 引入elementui 的中英文翻译
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import Cookies from "js-cookie";
import { getEnvInitInfo } from "@/assets/js/envConfig";

Vue.use(VueI18n);

try {
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get("userLanguage");
  let xy = ''
  if(!myParam) {
    xy = 'en'
  } else {
    xy = myParam
  }
  console.log("-------------", urlParams);
  console.log(myParam);
  console.log("-------------------");

  Cookies.set("userLanguage", xy);
} catch (ex) {
  console.log("Exep", ex);
}

let lang = "en";
const domain = document.domain
  .split(".")
  .slice(-2)
  .join(".");
if (getEnvInitInfo().envIsTVU) {
  if (!Cookies.get("userLanguage")) {
    lang = navigator.language || navigator.userLanguage || "en";
    Cookies.set("userLanguage", lang, { domain, expires: 1000000000 });
  } else {
    lang = Cookies.get("userLanguage");
  }
} else {
  lang = "zh"; // 如果环境是腾视目前规定只能选择中文
  Cookies.set("userLanguage", lang, { domain, expires: 1000000000 });
}

if (lang.indexOf("en") > -1) {
  // 对于en-US,en-UK,统一处理为en
  lang = "en";
} else if (lang.indexOf("zh") > -1) {
  // 对于zh-CN,zh-HK,zh-TW，统一处理为zh
  lang = "zh";
} else {
  lang = "en";
}

const locales = {
  en: Object.assign(require("./en"), enLocale),
  zh: Object.assign(require("./zh"), zhLocale), //合并文件 用来处理ui组件的中英文
};
const i18n = new VueI18n({
  locale: lang,
  messages: locales,
  silentTranslationWarn: true,
});

window.i18n = i18n;
export default i18n;
